const ImagemPrincipalSchema = () => ({
  title: 'Imagem Principal',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['preview_image_link', 'preview_caption_link'],
    },
  ],
  properties: {
    preview_image_link: {
      title: 'Imagem',
      description:
        'Mesma imagem usada no Painel de Controle (Imagem de Pré-visualização). Aparece também nos listings de notícias.',
      widget: 'object_browser',
      mode: 'image',
      allowExternals: false,
      selectableTypes: ['Image'],
    },
    preview_caption_link: {
      title: 'Legenda',
      description: 'Texto opcional mostrado abaixo da imagem.',
    },
  },
  required: [],
});

export default ImagemPrincipalSchema;
